<template>
  <div class="content">
    <div class="row">
    <div class="col-md-12 col-sm-12 col-xs-12 pad-bt-10">
      <router-link  class="btn btn-info" to="/reports"><i class="ti-arrow-left"></i> Back</router-link>
    </div>
    <div class="col-lg-4 col-md-5 col-sm-7 col-xs-12">
      <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              Cutomer Data
            </h4>
          </div>
          <div class=" card-content">
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12"><b>Name</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">{{customer.first_name}} {{customer.last_name}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12"><b>Email</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">{{customer.email}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12"><b>Phone</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">{{customer.phone}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12"><b>Gender</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">{{customer.gender}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12"><b>Birth Day</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">{{formatDate(customer.birth_day)}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12"><b>Location</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">{{customer.formatted_address}}</div>
            </div>
          </div>
          <div class="row card-footer">         
          </div>
      </div> <!-- end card -->
    </div> <!--  end col-md-12  -->
    <div class="col-md-8 col-sm-7 col-xs-12">
      <div class="card">
        <form class="">
          <div class="card-header">
            <h4 class="card-title">
              Sales Details 
            </h4>
          </div>
          <div class="row card-content">
            <data-tables class=""
                    :data="tableData"
                    :search-def="{show: false}"
                    :action-def="defaultActionDef"
                    :pagination-def="paginationDef"
                    :table-props="{'border': false}"
                    @row-click="goToRecord"
                    style="width: 100%">
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label"
                               sortable>
              </el-table-column> 
              <el-table-column
                :min-width="120"
                sortable
                prop="price"
                label="Total Amount">
                <template slot-scope="props">
                  {{formatMoneyAmount(props.row.total, props.row.currency)}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="100"
                sortable
                prop="status"
                label="Status">
                <template slot-scope="props">
                  <span class="label" :class="statusClass(props.row.status)" >{{props.row.status}}</span>
                </template>
              </el-table-column>
            </data-tables>
          </div>
          <div class="row card-footer">
          </div>
        </form>
      </div> <!-- end card -->
    </div> <!--  end col-md-12  -->
  </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option, DatePicker, Table} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import customerData from './../Customers/customer'
  import countriesList from './../Customers/countries'
  import orders from './../Orders/orders'
  import VueTabs from 'vue-nav-tabs'

  Vue.use(Select)
  Vue.use(DatePicker)
  Vue.use(DataTables)
  Vue.use(Table)
  Vue.use(VueTabs)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker
    },
    data () {
      return {
        paginationDef: {
          pageSize: 99999,
          currentPage: 1,
          pageSizes: [99999],
          show: false
        },
        customer: customerData,
        countries: countriesList,
        tableData: orders,
        modelValidations: {
          required: {
            required: true
          }
        },
        tableColumns: [
          {
            prop: 'number',
            label: 'Number',
            minWidth: 100
          },
          {
            prop: 'created_date',
            label: 'Date Created',
            minWidth: 150
          },
          {
            prop: 'delivery_service',
            label: 'Delivery',
            minWidth: 150
          },
          {
            prop: 'type',
            label: 'Type',
            minWidth: 100
          }
        ]
      }
    },
    methods: {
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/orders/view/')
      },
      statusClass (status) {
      }
    }
  }
</script>
<style scoped>
  .content {
    margin-top: 2%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/ReportsCustomerDetails.vue